import { TextField } from "@mui/material";
import { alertIfInvalidNumberEntry } from "./QuantityEntry";
import { handleWheel, handleKeyDown } from "../functions/eventHandlers";

const IntegerEntry = ({ elementName, fieldLabel, startingValue, setResourceState }) => {
    return <TextField style={{ width: "100%", marginTop: "12px", maxWidth: "260px" }}
        className="inputField" type='number' inputMode='numeric' label={fieldLabel} size="small" variant='outlined'
        value={startingValue ?? ""}
        onWheel={handleWheel}
        onKeyDown={handleKeyDown}
        onInput={alertIfInvalidNumberEntry}
        onChange={(e) => {
            if (e.target.value && !isNaN(e.target.value)) {
                if (parseInt(e.target.value) !== parseFloat(e.target.value)) {
                    alert("Only integers are allowed.");
                }
            }
            if (e.target.value === null || e.target.value === "" || e.target.value === undefined) {
                setResourceState(prevState => { return { ...prevState, [elementName]: "" }; });
            } else if (isNaN(e.target.value)) {
                setResourceState(prevState => { return { ...prevState, [elementName]: e.target.value }; });
            } else {
                setResourceState(prevState => { return { ...prevState, [elementName]: Number(e.target.value) }; });
            }
        }} />
};

export default IntegerEntry;